__turbopack_context__.v({
  "closeBtn": "WriteReviewModal-module__AgNh1a__closeBtn",
  "errorText": "WriteReviewModal-module__AgNh1a__errorText",
  "field": "WriteReviewModal-module__AgNh1a__field",
  "fieldFull": "WriteReviewModal-module__AgNh1a__fieldFull",
  "fieldLabel": "WriteReviewModal-module__AgNh1a__fieldLabel",
  "fieldLabelStatic": "WriteReviewModal-module__AgNh1a__fieldLabelStatic",
  "formBody": "WriteReviewModal-module__AgNh1a__formBody",
  "formGrid": "WriteReviewModal-module__AgNh1a__formGrid",
  "header": "WriteReviewModal-module__AgNh1a__header",
  "hiddenInput": "WriteReviewModal-module__AgNh1a__hiddenInput",
  "input": "WriteReviewModal-module__AgNh1a__input",
  "inputError": "WriteReviewModal-module__AgNh1a__inputError",
  "loaderContent": "WriteReviewModal-module__AgNh1a__loaderContent",
  "loaderOverlay": "WriteReviewModal-module__AgNh1a__loaderOverlay",
  "loaderSpinner": "WriteReviewModal-module__AgNh1a__loaderSpinner",
  "loaderText": "WriteReviewModal-module__AgNh1a__loaderText",
  "modal": "WriteReviewModal-module__AgNh1a__modal",
  "modalDesktop": "WriteReviewModal-module__AgNh1a__modalDesktop",
  "modalMobile": "WriteReviewModal-module__AgNh1a__modalMobile",
  "overlay": "WriteReviewModal-module__AgNh1a__overlay",
  "phoneField": "WriteReviewModal-module__AgNh1a__phoneField",
  "previewGrid": "WriteReviewModal-module__AgNh1a__previewGrid",
  "previewGroup": "WriteReviewModal-module__AgNh1a__previewGroup",
  "previewItem": "WriteReviewModal-module__AgNh1a__previewItem",
  "previewLabel": "WriteReviewModal-module__AgNh1a__previewLabel",
  "previewSection": "WriteReviewModal-module__AgNh1a__previewSection",
  "previewThumb": "WriteReviewModal-module__AgNh1a__previewThumb",
  "previewVideo": "WriteReviewModal-module__AgNh1a__previewVideo",
  "radioCustom": "WriteReviewModal-module__AgNh1a__radioCustom",
  "radioInput": "WriteReviewModal-module__AgNh1a__radioInput",
  "radioLabel": "WriteReviewModal-module__AgNh1a__radioLabel",
  "radioRow": "WriteReviewModal-module__AgNh1a__radioRow",
  "recommendBox": "WriteReviewModal-module__AgNh1a__recommendBox",
  "recommendBoxError": "WriteReviewModal-module__AgNh1a__recommendBoxError",
  "removeBtn": "WriteReviewModal-module__AgNh1a__removeBtn",
  "root": "WriteReviewModal-module__AgNh1a__root",
  "rootDesktop": "WriteReviewModal-module__AgNh1a__rootDesktop",
  "rootMobile": "WriteReviewModal-module__AgNh1a__rootMobile",
  "select": "WriteReviewModal-module__AgNh1a__select",
  "sheetUp": "WriteReviewModal-module__AgNh1a__sheetUp",
  "spin": "WriteReviewModal-module__AgNh1a__spin",
  "starBtn": "WriteReviewModal-module__AgNh1a__starBtn",
  "starsRow": "WriteReviewModal-module__AgNh1a__starsRow",
  "starsRowError": "WriteReviewModal-module__AgNh1a__starsRowError",
  "submitBtn": "WriteReviewModal-module__AgNh1a__submitBtn",
  "subtitle": "WriteReviewModal-module__AgNh1a__subtitle",
  "textarea": "WriteReviewModal-module__AgNh1a__textarea",
  "title": "WriteReviewModal-module__AgNh1a__title",
  "uploadBox": "WriteReviewModal-module__AgNh1a__uploadBox",
  "uploadCount": "WriteReviewModal-module__AgNh1a__uploadCount",
  "uploadHint": "WriteReviewModal-module__AgNh1a__uploadHint",
  "uploadRow": "WriteReviewModal-module__AgNh1a__uploadRow",
  "uploadRowError": "WriteReviewModal-module__AgNh1a__uploadRowError",
  "uploadRowSingle": "WriteReviewModal-module__AgNh1a__uploadRowSingle",
  "uploadSection": "WriteReviewModal-module__AgNh1a__uploadSection",
  "uploadTextGroup": "WriteReviewModal-module__AgNh1a__uploadTextGroup",
  "uploadTitle": "WriteReviewModal-module__AgNh1a__uploadTitle",
});
